// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"208":"fedTools","924":"special"}[chunkId] + "." + {"208":"2a9e019a","924":"69a0677a"}[chunkId] + ".js";
};